import { z } from "zod";
import { PagedVideoItemDto, VideoDto, VideoSort } from "./video.ts";

export const MAX_FOLDER_DEPTH = 5;

export const FolderDto = z.object({
  externalId: z.string(),
  name: z.string(),
  parentFolderExternalId: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const CreateFolderDto = z.object({
  name: z.string().trim().min(1),
  parentFolderExternalId: z.string().nullable(),
});

export const RenameFolderDto = z.object({
  name: z.string().trim().min(1),
});

export const MoveFolderDto = z.object({
  parentFolderExternalId: z.string().nullable(),
});

export const MoveVideoToFolderDto = z.object({
  folderExternalId: z.string().nullable(),
});

export const FolderListQuery = z.object({
  parentFolderExternalId: z.string().optional(),
  sort: VideoSort.optional().default("lastUpdated"),
});

export const FolderContentsQuery = z.object({
  sort: VideoSort.optional().default("lastUpdated"),
});

export const FolderContentsResponse = z.object({
  folder: FolderDto.nullable(),
  breadcrumb: z.array(FolderDto),
  folders: z.array(FolderDto),
  videos: z.array(PagedVideoItemDto),
});

export const DeleteFolderResponse = z.object({
  deletedAt: z.string(),
});

export const SearchVideosResponse = z.object({
  videos: z.array(VideoDto),
  folders: z.array(FolderDto),
});

export type FolderDto = z.infer<typeof FolderDto>;
export type CreateFolderDto = z.infer<typeof CreateFolderDto>;
export type RenameFolderDto = z.infer<typeof RenameFolderDto>;
export type MoveFolderDto = z.infer<typeof MoveFolderDto>;
export type MoveVideoToFolderDto = z.infer<typeof MoveVideoToFolderDto>;
export type FolderListQuery = z.infer<typeof FolderListQuery>;
export type FolderContentsQuery = z.infer<typeof FolderContentsQuery>;
export type FolderContentsResponse = z.infer<typeof FolderContentsResponse>;
export type DeleteFolderResponse = z.infer<typeof DeleteFolderResponse>;
export type SearchVideosResponse = z.infer<typeof SearchVideosResponse>;
